import { render } from "./MusicComposition.vue?vue&type=template&id=384fe16a&scoped=true"
import script from "./MusicComposition.vue?vue&type=script&lang=js"
export * from "./MusicComposition.vue?vue&type=script&lang=js"

import "./MusicComposition.vue?vue&type=style&index=0&id=384fe16a&lang=scss&scoped=true"

import exportComponent from "/Users/josiahsprankle/Desktop/personal/JDS-Music-Site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-384fe16a"]])

export default __exports__